export default __webpack_public_path__ + "static/media/whatsgg.f4f19c74.svg";